/* this file added by Bearer Web Developer  */
import React, { useContext } from 'react';
import styles from './businessName.module.scss';
import { ReservedOrderInfoContext } from '../contexts/reservedOrderInfo';
import { useThemeMode } from '../../../../../../states/contexts/theme';
import EarliestTime from '../../../../earliestTime';


const BusinessName: React.FC = () => {
    const reservedOrderDetails = useContext(ReservedOrderInfoContext);
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    const earliest_pickup_time = reservedOrderDetails?.earliest_pickup_time;
    const is_time_sensitive_order = reservedOrderDetails?.is_time_sensitive_order;
    const earliest = earliest_pickup_time && is_time_sensitive_order;
    return (
        <div className={styles.business_name} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            {earliest && <EarliestTime earliest_pickup_time={earliest_pickup_time}  />}
            {
                theme === 'dark' ? <img className={styles.confirmation} src="/confirmation-number-white.svg" alt="" width={20} height={20} /> :
                    <img className={styles.confirmation} src="/confirmation-number.webp" alt="" width={20} height={20} />
            }
            {/* <span>{reservedOrderDetails?.business_name || 'Seyco Invoice No.'} : {reservedOrderDetails?.client_order_number}</span> */}
            <span>{'Order #'} : {reservedOrderDetails?.client_order_number}</span>
        </div>
    )
}

export default BusinessName;